<template>
    <div class="user-files">
        <template v-for="(item, i) in items" :key="i">
            <div class="user-file-card flex between v-center">
                <div class="user-file-card__col">{{ item.name }}</div>
                <div class="user-file-card__col">
                    <div class="user-files__remove-btn" v-if="!item.value" @click="showFileUploaderForField[i]=!showFileUploaderForField[i]">
                      {{ params.translates.actionTextAdd }}
                    </div>
                    <template v-else>
                        <input type="hidden" :name="`${item.inputName}`" :value="item.value">
                        <div class="user-files__remove-btn" @click="onDelete(item, i)">{{ params.translates.actionTextDel }}</div>
                        /
                        <div class="user-files__remove-btn" @click="showFileUploaderForField[i]=true">{{ params.translates.actionTextSet }}</div>
                    </template>
                    <slot name="actions" :item="item" :index="i"></slot>
                </div>
            </div>
            <AFileUploader v-model="uploadedFiles[item.inputName]" :name="item.inputName" v-if="params.canUpload && showFileUploaderForField[i]"/>
        </template>

    </div>
</template>

<script>
import {ref, nextTick, watch} from 'vue'
import {AInput, ABtn} from "../ui";
import AFileUploader from "../ui/AFileUploader";

export default {
    name: 'UserFiles',
    props: {
        items: {
            type: Array,
            default: () => [],
        },
        name: String,
        params: {
            type: Object,
            default: () => {
                return {
                    canUpload: false,         // можно ли добавлять файлы
                    translates: {}
                }
            },
        }
    },
    components: {
        AFileUploader,
        AInput,
        ABtn
    },

    emits: ['update:modelValue','onDelete'],

    setup: (props, ctx) => {
        const showFileUploaderForField = ref({})
        const uploadField = ref(null)
        const uploadedFiles = ref({})

        watch(uploadedFiles.value, val => {
            ctx.emit('update:modelValue', val)
        })

        const onDelete = (item, i) => {
            uploadedFiles.value[item.inputName] = null;
          ctx.emit('onDelete', {key: i, item})
        }

        return {
            showFileUploaderForField,
            uploadField,
            uploadedFiles,
            onDelete
        }
    },
}
</script>

<style lang="scss" scoped>
.user-file-card {
    padding: 0 30px;
    border-radius: 0;
    border-color: var(--c-gray-700);
    border: 1px solid var(--c-gray-700);
    margin-bottom: -1px;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    min-height: 70px;

    @include tablet {
        padding: 0 24px;
    }
    @include mobile {
        padding: 0 16px;
    }

    &:first-child {
        border-top-left-radius: 6px;
        border-top-right-radius: 6px;
    }

    &:last-child {
        border-bottom-left-radius: 6px;
        border-bottom-right-radius: 6px;
        border-bottom: 1px solid var(--c-gray-700);
    }


    &__col {
        display: flex;
        &:first-child {
            @include mobile {
                max-width: 150px;
            }
        }
    }
}

.user-files__remove-btn{
    cursor: pointer;
}
</style>